<script lang="ts">
	import { Button, LineContainer, Icon, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { ComponentVariant } from '@Shelly/shelly-design-system/helpers/enums';
	import { capFirstChar } from 'src/helpers/utilities';
	import { user_data } from 'src/stores/account/user';
import { scrollToPremiumSubs } from 'src/stores/ui/promotions';
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';

	export let isMobile = false;

	$: isSharedHome = isActiveHomeShared();

	$: isPremium = $user_data?.premium;
	$: title = isPremium
		? $format('premium', { default: 'Premium' })
		: $format('type_push', { default: 'Standard' });
	$: icon = isPremium && 'fas fa-gem icon-premium-color';
	let buttonProps: {
		title: string;
		type: `${ComponentVariant.PREMIUM}` | `${ComponentVariant.PRIMARY}`;
	} = {
		title: $format('export_premium_heading', {
			default: 'Explore Premium',
		}),
		type: `${ComponentVariant.PREMIUM}`,
	};

	$: {
		if (isPremium) {
			buttonProps.title = $format('export_premium_heading', {
				default: 'Explore Premium',
			});
			buttonProps.type = `${ComponentVariant.PREMIUM}`;
		} else {
			buttonProps.title = $format('upgrade_plan_heading', {
				default: 'Upgrade plan',
			});
			buttonProps.type = `${ComponentVariant.PRIMARY}`;
		}
	}

	$: premiumUrl = '/settings/premium';

	const onBtnClick = () => {
		if (!isPremium) {
			$scrollToPremiumSubs = true;
		}
		push(premiumUrl);
	};
</script>

<LineContainer
	accentColor={isPremium ? '--gradient-premium' : '--gradient-primary-horizontal'}
	class={classMap({
		'd-flex align-items-start flex-wrap': true,
		'flex-direction-column': !isMobile,
		'flex-direction-row justify-content-between align-items-center': isMobile,
	})}
	style={!isMobile && 'width: 328px;'}
>
	<div class="d-flex flex-1 flex-direction-column justify-content-center">
		<div
			class={classMap({
				'd-flex mb-xxs pt-xs pb-xs': true,
				'gap-s align-items-center': isPremium,
			})}
		>
			<Text
				class={classMap({
					'icon-premium-color': isPremium,
					'text-primary': !isPremium,
				})}
				styleType="h1"
			>
				{capFirstChar(title)}
			</Text>

			{#if icon}
				<Icon size="s" {icon} />
			{/if}
		</div>
		<Text styleType="tiny" class="text-color-muted text-bold">
			{$format('current_plan_heading', {
				default: 'Current plan',
			}).toUpperCase()}
		</Text>
	</div>
	<div
		class={classMap({
			'd-flex width-full': true,
			'flex-nowrap gap-m': !isMobile,
			'flex-wrap gap-s': isMobile,
		})}
		slot="footer"
	>
		{#if !isSharedHome}
			<Button
				class="min-width-md-s min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				on:click={onBtnClick}
				size="m"
				variant={buttonProps?.type}
			>
				{buttonProps?.title}
			</Button>
			<Text
				href="/"
				class="pt-s size-m-button-min-height link-underline width-md-auto width-sm-full text-center"
				styleType="controls-small"
				noWrap
				on:click={(e) => {
					e.preventDefault();
					push(premiumUrl);
				}}
			>
				{$format('redeem_voucher_prompt', { default: 'Redeem voucher' })}
			</Text>
		{/if}
	</div>
</LineContainer>
